import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { commonFilterMeta, Pagination, TableHeader } from '../../clientModule/components/Common/Table/types';
import PaginationMobile from '../../../pages/Responsive/PaginationMobile';
import { setActiveTab, setJurisdictions, setSelectedJurisdiction } from '../../../redux/slices/wikiSlice';
import { RootState } from '../../../redux/root';
import useFilterActions from '../../../pages/Responsive/useFilterActions';
import { useGetJurisdictionsByStateQuery } from '../../../redux/rtkQuery/apiWikiSlice';
import Table from '../../clientModule/components/Common/Table/Table';
import history from '../../../history';
import { ROUTES } from '../../../constants/routes';
import PropertyAppraiserLookup from '../PropertyAppraiserLookup/PropertyAppraiserLookup';
import JurisdictionAuditLog from './JurisdictionAuditLog';

const JurisdictionTable = () => {
  const [auditJurisdiction, setAuditJurisdiction] = useState<any>(null);
  const dispatch = useDispatch();
  // @ts-ignore
  const { wikiId } = useParams();
  const selectedState = useSelector((s: RootState) => s.wikiSlice.selectedState);
  const { data, isFetching } = useGetJurisdictionsByStateQuery(selectedState.id, {
    skip: selectedState?.id === undefined,
  });

  const jurisdictions = useSelector((s: RootState) => s.wikiSlice.jurisdictions);
  const filtered = useFilterActions(jurisdictions);

  useEffect(() => {
    if (data) {
      dispatch(setJurisdictions(data));
    }
  }, [data, wikiId]);

  const headers: TableHeader[] = [
    {
      label: 'Jurisdiction Name',
      theKey: 'jurisdictions',
      itemName: 'jurisdictions',
    },
    {
      label: 'Jurisdiction Website',
      theKey: 'jurisdictionWebsite',
      itemName: 'jurisdictionWebsite',
    },

    {
      label: 'County',
      theKey: 'county',
      itemName: 'county',
    },
    {
      label: 'Address',
      theKey: 'address',
      itemName: 'address',
    },
    {
      label: 'Actions',
      theKey: '',
      itemName: '',
      hideFilter: true,
    },
  ];

  const setSelectedItemInSlice = jurisdiction => {
    dispatch(setSelectedJurisdiction(jurisdiction));
    dispatch(setActiveTab('None'));
    history.push(`${ROUTES.WIKI}/${jurisdiction.id}`);
  };
  return (
    <div>
      <PropertyAppraiserLookup />
      <TableWrapper>
        <Table
          collection={filtered}
          headers={headers}
          filterMeta={commonFilterMeta}
          gridTemplateCols="1fr 1fr 1fr 1fr 100px"
          setSelectedItemInSlice={setSelectedItemInSlice}
          onAudit={setAuditJurisdiction}
          isLoading={isFetching}
          // showFilters={false}
        />
        <Pagination>
          <PaginationMobile showEverywhere />
        </Pagination>
      </TableWrapper>
      {auditJurisdiction && (
        <JurisdictionAuditLog
          jurisdiction={auditJurisdiction}
          onClose={() => setAuditJurisdiction(null)}
        />
      )}
    </div>
  );
};

export default JurisdictionTable;

const TableWrapper = styled.div`
  height: 55%;
`;

export const Label = styled.div`
  font-size: 14px;
  font-weight: bold;
  text-align: right;
  padding-right: 9px;
  position: relative;
  top: 5px;
`;

export const Controls = styled.div`
  height: 43px;
  display: grid;
  grid-template-columns: 53px 1fr;
  margin-left: 34px;
  margin-top: 22px;
  select,
  input {
    height: 30px;
    border-radius: 5px;
  }
`;

export const ControlsRows = styled.div`
  display: flex;
`;
